// @flow
import React, { type Node } from 'react';
import cn from 'classnames/bind';
import isEmpty from 'ramda/es/isEmpty';

import type { Mark as MarkType } from 'app/dataTypes/Mark.types';

import useIsExpandable from './useIsExpandable';
import Mark from './Mark';
import styles from './MarkList.scss';


const cx = cn.bind(styles);

type Props = {
  className?: string,
  overflowClassName?: string,
  marks: Array<MarkType>,
}

const MarkList = ({ className, overflowClassName, marks }: Props): Node => {
  const nothing = isEmpty(marks);
  const [ref, expandable] = useIsExpandable(nothing);
  const commaCount = marks.length - 1;

  const rootClassName = cx(
    styles.root,
    { expandable },
    expandable ? overflowClassName : '',
    className
  );

  if (nothing) {
    return null;
  }

  return (
    <div className={rootClassName}>
      <div ref={ref} className={styles.content}>
        {marks.map((props, i) => (
          <Mark key={i} {...props} tail={i < commaCount} />
        ))}
      </div>
    </div>
  );
};

export default MarkList;
